<script>
export default {
  name: 'CustomerSelect',
}
</script>
<template>
  <customer-all-select
    v-bind="$attrs"
    v-on="$listeners"
    :customer="true"
  ></customer-all-select>
</template>